"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.TYPE_OPTIONS = exports.ELEMENT_OPTIONS = void 0;
var ELEMENT_OPTIONS = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  DIV: "div"
};
exports.ELEMENT_OPTIONS = ELEMENT_OPTIONS;
var TYPE_OPTIONS = {
  DISPLAY: "display",
  DISPLAYSUBTITLE: "displaySubtitle",
  TITLE1: "title1",
  TITLE2: "title2",
  TITLE3: "title3",
  TITLE4: "title4",
  TITLE5: "title5"
};
exports.TYPE_OPTIONS = TYPE_OPTIONS;
var TOKENS = {
  weightHeading: "weightHeading",
  sizeHeading: "sizeHeading",
  lineHeight: "lineHeight"
};
exports.TOKENS = TOKENS;